import { isMobileQuery } from "../utils/utils"

class Accordion {
  constructor() {
    this.buttons = document.querySelectorAll("[data-accordion-trigger]")

    for (let i = 0; i < this.buttons.length; i++) {
      let button = this.buttons[i]

      // Whether or not the accordion is for mobile only
      let mobileOnly = button.getAttribute("data-accordion-mobile")

      // Add click event to mobile only element or no limitation
      if ((mobileOnly && isMobileQuery.matches) || !mobileOnly) {
        button.addEventListener("click", ev => {
          ev.preventDefault()
          this.toggleCollapse(button)
        })
      }
    }
  }

  toggleCollapse(button) {
    const target = button.getAttribute("data-accordion-trigger")
    const accordionContent = document.querySelector(target)
    if (accordionContent.classList.contains("show")) {
      button.classList.remove("active")
      accordionContent.classList.remove("show")
      accordionContent.setAttribute("aria-expanded", "false")
    } else {
      button.classList.add("active")
      accordionContent.classList.add("show")
      accordionContent.setAttribute("aria-expanded", "true")
    }
  }
}

export default Accordion
